const mode = {
  EXPLICIT: 'EXPLICIT',
  IMPLICIT: 'IMPLICIT',
  IMPORTED: 'IMPORTED'
}

export default mode
